// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Orders — Filter Section (page-specific) ===== */
.ord-filters-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  gap: 0.5rem;
  margin-top: 0.75rem;
}
.ord-field {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  min-width: 0;
}
.ord-field--name  { width: 10rem; }
.ord-field--id    { width: 7.5rem; }
.ord-field--acc   { width: 7.5rem; }
.ord-field--body  { width: 9.375rem; }
.ord-field--ordno { width: 7.5rem; }
.ord-field--date  { width: 16rem; }
.ord-field--status { width: 9.375rem; }
.ord-filters-row .ant-input,
.ord-filters-row .ant-picker,
.ord-filters-row .ant-select {
  width: 100% !important;
}
/* ===== Orders table — denser layout so the reference columns fit on one screen =====
   Scoped to .orders-list so the other AgGridTable consumers (Worklist, Dispatch,
   QC, Consultant) keep their default spacing. */
.orders-list .pacs-ag-grid .ag-cell {
  padding: 0 8px;
}
.orders-list .pacs-ag-grid .ag-header-cell {
  padding-left: 8px;
  padding-right: 8px;
}
/* Allow long headers (e.g. "Scheduled / Order Date") to wrap to two lines
   instead of forcing a wider column. */
.orders-list .pacs-ag-grid .ag-header-cell-label {
  white-space: normal;
  line-height: 1.1;
}

`, "",{"version":3,"sources":["webpack://./pages/orders/orders.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,YAAY;AACd;AAEA,oBAAoB,YAAY,EAAE;AAClC,oBAAoB,aAAa,EAAE;AACnC,oBAAoB,aAAa,EAAE;AACnC,oBAAoB,eAAe,EAAE;AACrC,oBAAoB,aAAa,EAAE;AACnC,oBAAoB,YAAY,EAAE;AAClC,qBAAqB,eAAe,EAAE;AAEtC;;;EAGE,sBAAsB;AACxB;AAEA;;gDAEgD;AAChD;EACE,cAAc;AAChB;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;uCACuC;AACvC;EACE,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["/* ===== Orders — Filter Section (page-specific) ===== */\r\n.ord-filters-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-end;\r\n  gap: 0.5rem;\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.ord-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.ord-field--name  { width: 10rem; }\r\n.ord-field--id    { width: 7.5rem; }\r\n.ord-field--acc   { width: 7.5rem; }\r\n.ord-field--body  { width: 9.375rem; }\r\n.ord-field--ordno { width: 7.5rem; }\r\n.ord-field--date  { width: 16rem; }\r\n.ord-field--status { width: 9.375rem; }\r\n\r\n.ord-filters-row .ant-input,\r\n.ord-filters-row .ant-picker,\r\n.ord-filters-row .ant-select {\r\n  width: 100% !important;\r\n}\r\n\r\n/* ===== Orders table — denser layout so the reference columns fit on one screen =====\r\n   Scoped to .orders-list so the other AgGridTable consumers (Worklist, Dispatch,\r\n   QC, Consultant) keep their default spacing. */\r\n.orders-list .pacs-ag-grid .ag-cell {\r\n  padding: 0 8px;\r\n}\r\n\r\n.orders-list .pacs-ag-grid .ag-header-cell {\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n}\r\n\r\n/* Allow long headers (e.g. \"Scheduled / Order Date\") to wrap to two lines\r\n   instead of forcing a wider column. */\r\n.orders-list .pacs-ag-grid .ag-header-cell-label {\r\n  white-space: normal;\r\n  line-height: 1.1;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
